<template>
    <div class="summary-container">
        <div class="text-center summary-title">题目：{{ topic }}</div>
        <div>
            <div class="summary-content">
              <template v-for="(item, l1) in titleList">
                <!-- 一级标题 -->
                 <TitleRow :key="item.id" :row="item"
                           :add-new="addRow"
                           @delete-row="deleteRow">第{{ 1 + l1 }}章</TitleRow>

                <!-- 二级标题 -->
                <template v-if="item.children && item.children.length">
                    <template v-for="(child, l2) in item.children">
                        <TitleRow :key="child.id" :row="child"
                                  :add-new="addRow"
                                  @delete-row="deleteRow">{{ 1 + l1 }}.{{ 1 + l2 }}</TitleRow>

                        <template v-if="child.children && child.children.length">
                            <!-- 三级标题 -->
                            <TitleRow v-for="(leaf, l3) in child.children" :key="leaf.id"
                                      :row="leaf"
                                      @delete-row="deleteRow">{{ 1 + l1 }}.{{ 1 + l2 }}.{{ 1 + l3 }}</TitleRow>
                        </template>
                    </template>
                </template>
              </template>

              <div v-if="loading" class="loading-btn row items-center">
                <div>大纲生成中</div>
                <i class="el-icon-loading"></i>
              </div>
              <div v-if="!loading && titleList.length" class="summary-footer">
                <div class="summary-statement">
                  <i class="el-icon-info"></i>
                  本内容由AI生成，仅供参考，不代表我方立场或观点，请甄别使用。
                </div>
                <div class="summary-reset cursor-pointer row items-center" @click.stop="showSummary">
                  <span>大纲不满意？重新生成</span>
                  <i class="el-icon-refresh reset-icon"></i>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleRow from './title-row.vue'
import { generateRandomString } from '@/utils/common-function'
export default {
    components: {
        TitleRow
    },
    props: {
        topic: { // 论文标题
            type: String,
            default: ''
        },
        setTypingDone: { // 打印完成回调
            type: Function,
            required: false
        }
    },
    data () {
        return {
            mainContainer: null, // 父容器，输出时的滚动参照物

            loading: false, // 是否加载数据
            sseData: [], // 等待出栈的数据（来自接口）

            titleList: [], // 显示内容
            responseData: [], // 大纲列表（后端一次返回多个大纲，刷新时使用）
            currIndex: -1, // 当前使用的大纲索引
            nodeKeys: [], // 标题的唯一标识集合，防止重复

            typingSpeed: 200, // 打字速度
            intervalId: null // 内容输出定时器id
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.mainContainer = document.querySelector('.outline-container')
        })
    },
    inject: ['showSummary'], // showSummary：生成大纲
    methods: {
        triggerTyping (resData) { // 每次取第一个大纲
            resData && (this.responseData = resData)

            this.titleList.length = 0 // 清除大纲
            // 使用第一个大纲
            const data = JSON.parse(JSON.stringify(this.responseData[0]))
            data.length && data.forEach((_, i) => this.traverseItem(_, i))
            this.titleList = data
            // this.titleList.length = 0
            // if (this.responseData[0] && this.responseData[0].length) {
            //     this.responseData[0].forEach((_, i) => this.traverseItem(_, i))
            //     this.titleList = this.responseData[0]
            // }

            // 滚动到底部
            this.$nextTick(() => {
                this.scrollToBottom()
            })
        },
        // 深度遍历每个标题：设置标题层级和前缀，并添加该标题到titleList
        async traverseItem (item, index, level = 1) {
            item.id = this.getUniqueId() // 唯一标识
            item.level = level // 设置每个标题的层级 1,2,3....
            // 其他
            item.editable = false // 是否可编辑
            !item.chartAndTable && (item.chartAndTable = [])

            const children = item.children || []
            children.length && children.forEach((_, i) => {
                this.traverseItem(_, i, level + 1)
            })
            // const finish = await typing(item)
            // if (finish) {
            //     const children = item.children || []
            //     children.length && children.forEach((_, i) => this.traverseItem(_, i, level + 1))
            // }
        },
        typing (item) { // 开始打印标题（打印完成，返回true）
            // const content = item.title || ''
            // if (!content.length) return true

            // const strArr = []
            // for (let i = 0; i < content.length; i += 2) {
            //     strArr.push(content.substr(i, 2))
            // }
            // const promiseArr = []
            // strArr.forEach(_ => promiseArr.push(new Promise(() => {

            // })))
        },
        addRow (item) {
            !item.children && this.$set(item, 'children', [])

            this.$set(item.children, item.children.length, {
                id: this.getUniqueId(),
                level: 1 + item.level,
                editable: true, // 是否可编辑
                chartAndTable: [],
                title: ''
            })
        },
        getUniqueId () { // 获取唯一标识（存储下来，便于下次做唯一性对比）
            let id = generateRandomString()
            while (this.nodeKeys.includes(id)) {
                id = generateRandomString()
            }
            this.nodeKeys.push(id)
            return id
        },
        scrollToBottom () { // 滚动到底部
            if (!this.mainContainer) return

            const top = this.mainContainer.scrollHeight // 以scrollHeight作为滚动位置，以便看到的总是最新内容
            // 滚动距离小于10px不滚动，减少dom操作
            if (Math.abs(top - this.mainContainer.scrollTop) <= 10) {
                return
            }
            this.mainContainer.scrollTo({
                top,
                behavior: 'smooth'
            })
        },
        deleteRow (item) { // 删除标题
            this.deleteById(this.titleList, item.id)
        },
        deleteById (list, id) { // 根据id删除节点
            const index = list.findIndex(_ => _.id === id)
            if (index === -1) {
                for (let i = 0; i < list.length; i++) {
                    if (this.deleteById(list[i].children || [], id)) {
                        return true
                    }
                }
            } else {
                list.splice(index, 1)
                return true
            }
        }
    }
}
</script>

<style lang="less" scoped>
.summary-container {
    padding: 12px;
    height: 100%;
    width: 100%;
    .summary-title {
        font-size: 20px;
        margin-bottom: 30px;
        margin-top: 20px;
    }
    .summary-content {
        height: 100%;
        border-radius: 8px;
        background-color: #ffffff;
        transition: border .2s;
        overflow: auto;
        padding: 12px;
        font-size: 14px;
        box-sizing: border-box;
        box-shadow: #cbd6e7 1px -1px 19px 0px;
      .loading-btn {
        width: max-content;
        margin: 24px auto 0;
        padding: 2px 14px;
        border-radius: 28px;
        color: #3680F9;
        border: 1px solid #3680F9;
        background-color: #ffffff;
        .loading-icon {
          margin-left: 8px;
        }
      }
      .summary-footer {
        margin-top: 20px;
        .summary-statement {
          text-align: center;
          color: #a3a3a3;
          font-size: 12px;
        }
        .summary-reset {
          width: max-content;
          margin: 24px auto 0;
          padding: 2px 14px;
          border-radius: 28px;
          color: #3680F9;
          border: 1px solid #3680F9;
          background-color: #ffffff;
          .reset-icon {
            margin-left: 4px;
            font-size: 16px;
          }
        }
      }
    }
}
</style>
